import React from "react";
import css from "./style.scss";
import { FullPage } from "components/container";
import api from "./api";
import store from "utils/store";
import Formsy from "formsy-react-2";
import Input from "components/shared/input";
import Button from "components/shared/button";

class ForgotPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: ""
    };
  }

  submit = model => {
    this.setState({ status: "loading" });
    api.forgotPassword(model).then(() => {
      this.setState({ status: "done" });
      store.dispatch({
        type: "ADD_TOAST",
        message: "You will receive an email with all password instructions"
      });
    });
  };

  render() {
    return (
      <FullPage withPadding withContainer dotted>
        <div>
          <div className={css.loginContainer}>
            <div className={css.login}>
              <h4>Forgot your password?</h4>
              <Formsy.Form onValidSubmit={this.submit}>
                <Input
                  type="text"
                  fullWidth={true}
                  required
                  label="Your email"
                  name="email"
                />
                <Button primary type="submit">
                  send instructions
                </Button>
              </Formsy.Form>
            </div>
          </div>
        </div>
      </FullPage>
    );
  }
}

export default ForgotPage;



// WEBPACK FOOTER //
// ./src/components/password/forgot.js